import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from "@lingui/core";

var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  var _a;
  let value;
  switch ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname == null ? void 0 : hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg, daMsg, svMsg) => {
  if (locale === "nb") return nbMsg;
  if (locale === "fi") return fiMsg;
  if (locale === "da") return daMsg;
  if (locale === "sv") return svMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages, daMessages, svMessages) => {
  const locale = detectLocale();
  const messages = getMessages(locale, enMessages, nbMessages, fiMessages, daMessages, svMessages);
  i18n.load(locale, messages);
  i18n.activate(locale);
};

var msgs = { "nb": { "icon.title.oikotielight": ["Oikotie"] }, "en": { "icon.title.oikotielight": ["Oikotie"] }, "fi": { "icon.title.oikotielight": ["Oikotie"] }, "da": { "icon.title.oikotielight": ["Oikotie lyst ikon"] }, "sv": { "icon.title.oikotielight": ["Oikotie"] } };
activateI18n(msgs.en, msgs.nb, msgs.fi, msgs.da, msgs.sv);
var IconOikotieLight42 = class extends LitElement {
  render() {
    const title = i18n.t({ message: `Oikotie`, id: "icon.title.oikotielight", comment: "Title for OikotieLight icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28">${unsafeStatic(`<title>${title}</title>`)}<path fill="#202020" d="M36.481 8.296H-.023V19.37h36.504L42 13.834l-5.52-5.538Z"></path><path fill="#fff" d="M10.189 16.3h1.07v-4.933h-1.07zm4.956.009-1.725-1.731-.012.012-.011-.012v1.724h-1.07V11.37h1.07v1.715l1.719-1.726h1.512l-2.452 2.46 2.481 2.491zm10.614-3.869H24.34v3.86h-1.07v-3.86h-1.439v-1.073h3.927v1.073Zm1.069 3.86h1.069v-4.933h-1.07V16.3Zm5.518-3.86h-2.299v.82h2.299v1.073h-2.299v.894h2.299V16.3h-3.38v-4.933h3.38zm-25.651.035c-.748 0-1.354.608-1.354 1.359 0 .75.606 1.359 1.354 1.359s1.355-.609 1.355-1.36c0-.75-.607-1.358-1.355-1.358m0 3.837a2.474 2.474 0 0 1-2.47-2.479 2.474 2.474 0 0 1 2.47-2.478c1.365 0 2.47 1.11 2.47 2.479a2.474 2.474 0 0 1-2.47 2.478"></path><path fill="#fff" d="M18.993 12.475c-.748 0-1.355.608-1.355 1.359 0 .75.607 1.359 1.355 1.359s1.354-.609 1.354-1.36c0-.75-.606-1.358-1.354-1.358m0 3.837a2.474 2.474 0 0 1-2.47-2.479 2.474 2.474 0 0 1 2.47-2.478c1.364 0 2.47 1.11 2.47 2.479a2.474 2.474 0 0 1-2.47 2.478"></path></svg>`;
  }
};
if (!customElements.get("fp-icon-oikotie-light-42")) {
  customElements.define("fp-icon-oikotie-light-42", IconOikotieLight42);
}
export {
  IconOikotieLight42
};
